<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="650"
    [nzVisible]="isVisibleRetailProgramsDrawer" [nzTitle]="retailProgramsDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.retailProgramsForm">
            <!-- <nz-skeleton *ngIf="isFetchingProgramDetails" [nzParagraph]="{ rows: 20}" [nzActive]="true"></nz-skeleton> -->
        <!-- Retail Program Logo Upload Section -->
        <div class="upload">
            <div>
                <button nz-button (click)="retailProgramLogoInput.click()" [nzLoading]="isLoadingSiteLogo"
                    class="update-logo-btn label-text required">
                    <i nz-icon nzType="picture" nzTheme="outline"></i>
                    Add/Update Retail Program Logo
                </button>
            </div>
            <input autocomplete="off" type="file" (change)="onFileChanged($event, 'retailProgramLogo')"
                #retailProgramLogoInput hidden accept="image/*" />
            <a *ngIf="retailProgramLogo" nz-popconfirm nzPopconfirmTitle="Are you sure you want to delete the logo?"
                nzPopconfirmPlacement="bottom" (nzOnConfirm)="removeImage('retailProgramLogo')">
                <i nz-icon nzType="delete" nzTheme="outline" class="delete-File ml-1"></i>
            </a>
        </div>

        <!-- Logo help text -->
        <div class="help-text">
            <i nz-icon nzType="info-circle" nzTheme="outline"></i>
            Upload a logo (JPEG, PNG, JPG, max 20MB)
        </div>

        <div class="d-flex align-i-c">
            <img *ngIf="retailProgramLogo" [src]="retailProgramLogo" alt="Retail Program Logo"
                style="max-width: 75%;" />
        </div>

        <!-- Retail Program Banner Images Upload Section -->
        <div class="upload">
            <div>
                <button nz-button (click)="retailProgramBannerImagesInput.click()" [nzLoading]="isLoadingBanner"
                    class="update-logo-btn label-text required">
                    <i nz-icon nzType="picture" nzTheme="outline"></i>
                    Add/Update Retail Program Banner Image
                </button>
            </div>
            <input autocomplete="off" type="file" (change)="onFileChanged($event, 'retailProgramBannerImages')"
                #retailProgramBannerImagesInput hidden accept="image/*" />
            <a *ngIf="retailProgramBannerImages" nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to delete the banner image?" nzPopconfirmPlacement="bottom"
                (nzOnConfirm)="removeImage('retailProgramBannerImages')">
                <i nz-icon nzType="delete" nzTheme="outline" class="delete-File ml-1"></i>
            </a>
        </div>

        <!-- Banner help text -->
        <div class="help-text">
            <i nz-icon nzType="info-circle" nzTheme="outline"></i>
            Upload a banner image (JPEG, PNG, JPG, max 20MB)
        </div>

        <div class="d-flex align-i-c">
            <img *ngIf="retailProgramBannerImages" [src]="retailProgramBannerImages" alt="Retail Program Banner Image"
                style="max-width: 75%;" />
        </div>

        <!-- Form Fields -->
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="programNameError">
                        <label class="label-text required">Program name</label>
                        <input type="text" pattern="^(?!\s+$).+" class="input-group" nz-input
                            formControlName="programName" maxlength="50" minlength="2"
                            [ngClass]="isEditMode && _fS.retailProgramsForm.value.programName === 'Wine.com' ? 'disable-input' : ''"
                            [readOnly]="isEditMode && _fS.retailProgramsForm.value.programName === 'Wine.com'"
                            (keypress)="_cS.checkAlphabetsWithSpaceCommaNumbers($event)">
                        <ng-template #programNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter Program Name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Program name
                                {{validationMessage.minlength}}</ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter Program Name</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <!-- Site Dropdown -->
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="siteError">
                        <label class="label-text required">Send Invoices to</label>
                        <nz-select nzShowSearch class="width-100" formControlName="siteId" nzPlaceHolder="Select a site"
                            (ngModelChange)="onSiteChange($event)" [nzDisabled]="isEditMode">
                            <ng-container *ngIf="!isFetchingProgramDetails">
                            <nz-option *ngFor="let site of sites" [nzValue]="site.id" [nzLabel]="site.name"
                                [nzDisabled]="site.isAssigned"></nz-option>
                                </ng-container>
                                 <nz-option nzDisabled nzCustomContent *ngIf="isFetchingProgramDetails">
                                    <i nz-icon nzType="loading" class="loading-icon"></i>
                                    Loading Data...
                                </nz-option>
                        </nz-select>
                        <ng-template #siteError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please select a Site</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                     <!-- [nzErrorTip]="descErr" -->
                    <nz-form-control>
                        <label class="label-text">Invoice description text</label>
                        <textarea type="text" placeholder="Enter invoice description"
                            class="input-group" nz-input formControlName="invoiceDescriptionText"
                            [nzAutosize]="{ minRows: 4, maxRows: 6 }"
                            maxlength="1000"></textarea>
                        <!-- <ng-template #descErr let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter invoice description text</ng-container>
                        </ng-template> -->
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <!-- Visible Toggle -->
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item class="margin-none">
                    <nz-form-control class="switch-box">
                        <label nz-checkbox formControlName="isActiveRetailPrograms">Visible</label>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex">
            <button nz-button nzType="primary" (click)="handleOk()" class="medium-btn small-btn width-100 mr-1"
                [nzLoading]="isLoadingOne">{{retailProgramsData != null ? 'Update' : 'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()" class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>